import React from 'react';
import Container from '../../layout/container/Container';
import CellAbstract from './CellAbstract';
import { CELL_TEXT_COUNTER_TAG_PROPS } from './Types';

class CellTextCounterTag extends CellAbstract<CELL_TEXT_COUNTER_TAG_PROPS, {}> {
  renderContainer = (value = []) => {
    const [firstValue, ...tooltipValues] = value;
    let tagsContent = (
      <>
        {firstValue}
        {tooltipValues.length !== 0 ? (
          <>
            &nbsp;
            {this.renderTooltip(
              <span
                key={tooltipValues[0]}
                className={'tp-text-counter-tag-cell tp-text-ellipsis'}
              >
                +{tooltipValues.length}
              </span>,
              {
                content: () => (<>
                  <ul className="tp-text-counter-tag-cell-tooltip">
                    {tooltipValues.map(val => <li key={val}>{val}</li>)}
                  </ul>
                </>),
                title: tooltipValues.join(),
                position: 'right'
              }
            )}
          </>
        ) : null}
      </>
    );
    return (
      <Container
        hBox
        alignItemsCenter
        className={'tp-text-ellipsis'}
      >
        {tagsContent}
      </Container>
    );
  }

  render() {
    const {
      dataIndex,
      dataItem,
      field
    } = this.props;

    const value = dataItem[(field || dataIndex)];

    return this.renderWrapper(this.renderContainer(value));
  }
}

export default CellTextCounterTag;
